// extracted by mini-css-extract-plugin
export default {"wrapper":"SuggestionSearch_wrapper__gjoiD","suggestions":"SuggestionSearch_suggestions__PDWr1","input":"SuggestionSearch_input__L-TyB"};